import { useState, useEffect, useContext } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";

// MindPlus components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// MindPlus examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Data
import dataTableData from "layouts/programs/program-list/data/dataTableData";
import { NavLink } from "react-router-dom";

import { DataContext } from "context/dataContext";

function ProgramList() {
  const { dataState, sendMail } = useContext(DataContext);

  const [data, setData] = useState({ ...dataTableData, rows: [] });

  const [menu, setMenu] = useState(null);

  const openMenu = (event) => setMenu(event.currentTarget);
  const closeMenu = () => setMenu(null);

  function handleMail() {
    sendMail({
      to: "prashant.goraparthi@gmail.com",
      body: "Test Message for SES",
      subject: "Testing MindPlus Emails",
      code: 3213,
    }).then((res) => {
      if (res.success) {
        console.log("email sent", res);
      } else {
        console.log("Something went wrong");
      }
    });
  }

  useEffect(() => {
    console.log(dataState.all_programs);
    setData((prevData) => ({
      ...prevData,
      rows: dataState.all_programs.map((program) => {
        return {
          ...program,
        };
      }),
    }));
  }, [dataState.all_programs]);

  const renderMenu = (
    <Menu
      anchorEl={menu}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      open={Boolean(menu)}
      onClose={closeMenu}
      keepMounted
    >
      <MenuItem onClick={closeMenu}>Free</MenuItem>
      <MenuItem onClick={closeMenu}>Premium</MenuItem>
      <MenuItem onClick={closeMenu}>Demo</MenuItem>
      <Divider sx={{ margin: "0.5rem 0" }} />
      <MenuItem onClick={closeMenu}>
        <MDTypography variant="button" color="error" fontWeight="regular">
          Remove Filter
        </MDTypography>
      </MenuItem>
    </Menu>
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox my={3}>
        <MDBox display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
          <MDButton
            variant="gradient"
            color="primary"
            component={NavLink}
            to="/programs/new-program"
          >
            New Program
          </MDButton>
          {/* <MDButton variant="gradient" color="primary" onClick={handleMail}>
            Send Mail{" "}
          </MDButton> */}
          <MDBox display="flex">
            <MDButton variant={menu ? "contained" : "outlined"} color="dark" onClick={openMenu}>
              filters&nbsp;
              <Icon>keyboard_arrow_down</Icon>
            </MDButton>
            {renderMenu}
            <MDBox ml={1}>
              <MDButton variant="outlined" color="dark">
                <Icon>description</Icon>
                &nbsp;export csv
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
        <Card>
          {data.rows.length > 0 ? (
            <DataTable table={data} canSearch />
          ) : (
            <MDBox p={2}>
              <MDTypography>No Data</MDTypography>
            </MDBox>
          )}
        </Card>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ProgramList;
